import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { RoleService } from 'src/app/services/role-service';
import { EmployeService } from 'src/app/services/employe-service';
import { RoleEntite } from 'src/app/entites/role';
import { TacheEntite } from 'src/app/entites/tache';
import { EmployeEntite } from 'src/app/entites/employe';
import { RequeteModifierRoles } from 'src/app/services/requetes/requete-modifier-roles';

@Component({
    templateUrl: './detail-role.component.html',
    styleUrls: ['./detail-role.component.scss'],
    providers: [MessageService]
})
export class DetailRoleComponent implements OnInit {

    role: RoleEntite;
    tachesDisponibles: TacheEntite[] = [];
    tachesSelectionnees: TacheEntite[] = [];
    employesDisponibles: EmployeEntite[] = [];
    employesAvecRole: EmployeEntite[] = [];
    employesSelectionnes: EmployeEntite[] = [];

    afficherDialogueRolesEmploye: boolean = false;
    employe: EmployeEntite;

    // États initiaux pour détecter les changements
    tachesInitiales: TacheEntite[] = [];
    employesInitiaux: EmployeEntite[] = [];

    modeEdition: boolean = false;
    submitted: boolean = false;
    chargementEnCours: boolean = false;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private roleService: RoleService,
        private employeService: EmployeService,
        private messageService: MessageService
    ) {}

    ngOnInit() {
        // Récupérer les données passées au dialogue
        this.role = this.config.data?.role ? { ...this.config.data.role } : { roleId: 0, nom: '', taches: [] };
        const toutesLesTaches = this.config.data?.taches || [];
        const tousLesEmployes = this.config.data?.employes || [];
        
        console.log('Role data:', this.role);
        console.log('Role taches:', this.role.taches);
        console.log('Role employes:', this.role.employes);
        console.log('Toutes les taches:', toutesLesTaches.length);
        console.log('Tous les employes:', tousLesEmployes.length);
        
        this.modeEdition = this.role.roleId > 0;

        if (this.modeEdition) {
            this.initialiserDonneesExistantes(toutesLesTaches, tousLesEmployes);
            // Filtrer les listes disponibles pour exclure les éléments déjà assignés
            this.filtrerListesDisponibles(toutesLesTaches, tousLesEmployes);
        } else {
            // En mode création, toutes les tâches et employés sont disponibles
            this.tachesDisponibles = [...toutesLesTaches];
            this.employesDisponibles = [...tousLesEmployes];
        }
    }

    /**
     * Initialise les données pour un rôle existant
     */
    initialiserDonneesExistantes(toutesLesTaches: TacheEntite[], tousLesEmployes: EmployeEntite[]) {
        // Sélectionner les tâches déjà associées au rôle
        if (this.role.taches && this.role.taches.length > 0) {
            this.tachesSelectionnees = toutesLesTaches.filter(tache =>
                this.role.taches.some(t => t.tacheId === tache.tacheId)
            );
            console.log('Taches selectionnees:', this.tachesSelectionnees.length);
        } else {
            this.tachesSelectionnees = [];
            console.log('Aucune tache dans le role');
        }

        // Trouver les employés qui ont ce rôle en utilisant la liste d'employés du rôle
        if (this.role.employes && this.role.employes.length > 0) {
            // Matcher les employeIds du rôle avec les employés complets
            this.employesAvecRole = tousLesEmployes.filter(employe =>
                this.role.employes.some(roleEmploye => roleEmploye.employeId === employe.employeId)
            );
            console.log('Employes avec role:', this.employesAvecRole.length);
        } else {
            this.employesAvecRole = [];
            console.log('Aucun employe dans le role');
        }
        
        this.employesSelectionnes = [...this.employesAvecRole];

        // Sauvegarder les états initiaux pour détecter les changements
        this.tachesInitiales = [...this.tachesSelectionnees];
        this.employesInitiaux = [...this.employesSelectionnes];
    }

    /**
     * Filtre les listes disponibles pour exclure les éléments déjà assignés au rôle
     */
    filtrerListesDisponibles(toutesLesTaches: TacheEntite[], tousLesEmployes: EmployeEntite[]) {
        // Filtrer les tâches disponibles (exclure celles déjà sélectionnées)
        this.tachesDisponibles = toutesLesTaches.filter(tache => 
            !this.tachesSelectionnees.some(ts => ts.tacheId === tache.tacheId)
        );

        // Filtrer les employés disponibles (exclure ceux déjà sélectionnés)
        this.employesDisponibles = tousLesEmployes.filter(employe => 
            !this.employesSelectionnes.some(es => es.employeId === employe.employeId)
        );
    }

    /**
     * Sauvegarde le rôle (création ou modification)
     */
    sauvegarder() {
        this.submitted = true;

        if (!this.role.nom || this.role.nom.trim() === '') {
            this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Le nom du rôle est obligatoire'
            });
            return;
        }

        this.chargementEnCours = true;

        // Préparer le rôle avec les tâches sélectionnées
        const roleAEnregistrer: RoleEntite = {
            ...this.role,
            nom: this.role.nom.trim(),
            taches: this.tachesSelectionnees
        };

        if (this.modeEdition) {
            this.modifierRole(roleAEnregistrer);
        } else {
            this.creerRole(roleAEnregistrer);
        }
    }

    /**
     * Crée un nouveau rôle
     */
    creerRole(role: RoleEntite) {
        this.roleService.ajouterRole(role).subscribe({
            next: (roleCreated) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Succès',
                    detail: 'Rôle créé avec succès'
                });
                
                // Assigner les employés au nouveau rôle si nécessaire
                if (this.employesSelectionnes.length > 0) {
                    this.assignerEmployesAuRole(roleCreated.roleId);
                } else {
                    this.fermerDialogue(true);
                }
            },
            error: (error) => {
                this.chargementEnCours = false;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: error.message || 'Erreur lors de la création du rôle'
                });
            }
        });
    }

    /**
     * Modifie un rôle existant
     */
    modifierRole(role: RoleEntite) {
        // Modifier les tâches du rôle
        const tacheIds = this.tachesSelectionnees.map(t => t.tacheId);
        
        this.roleService.modifierTachesRole(role.roleId, tacheIds).subscribe({
            next: (success) => {
                if (success) {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Succès',
                        detail: 'Tâches du rôle modifiées avec succès'
                    });
                    
                    // Gérer les changements d'employés
                    this.gererChangementsEmployes();
                } else {
                    this.chargementEnCours = false;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: 'Erreur lors de la modification des tâches'
                    });
                }
            },
            error: (error) => {
                this.chargementEnCours = false;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: error.message || 'Erreur lors de la modification du rôle'
                });
            }
        });
    }

    /**
     * Gère les changements d'employés (ajouts/suppressions)
     */
    gererChangementsEmployes() {
        const employesAjoutes = this.employesSelectionnes.filter(emp => 
            !this.employesAvecRole.some(empRole => empRole.employeId === emp.employeId)
        );
        
        const employesRetires = this.employesAvecRole.filter(empRole => 
            !this.employesSelectionnes.some(emp => emp.employeId === empRole.employeId)
        );

        let operationsTerminees = 0;
        const totalOperations = employesAjoutes.length + employesRetires.length;

        if (totalOperations === 0) {
            this.fermerDialogue(true);
            return;
        }

        // Ajouter les nouveaux employés
        employesAjoutes.forEach(employe => {
            this.ajouterEmployeAuRole(employe.employeId, () => {
                operationsTerminees++;
                if (operationsTerminees === totalOperations) {
                    this.fermerDialogue(true);
                }
            });
        });

        // Retirer les employés
        employesRetires.forEach(employe => {
            this.retirerEmployeDuRole(employe.employeId, () => {
                operationsTerminees++;
                if (operationsTerminees === totalOperations) {
                    this.fermerDialogue(true);
                }
            });
        });
    }

    /**
     * Assigne tous les employés sélectionnés au rôle
     */
    assignerEmployesAuRole(roleId: number) {
        let operationsTerminees = 0;
        const totalEmployes = this.employesSelectionnes.length;

        this.employesSelectionnes.forEach(employe => {
            this.ajouterEmployeAuRole(employe.employeId, () => {
                operationsTerminees++;
                if (operationsTerminees === totalEmployes) {
                    this.fermerDialogue(true);
                }
            });
        });
    }

    /**
     * Ajoute un employé à un rôle
     */
    ajouterEmployeAuRole(employeId: number, callback?: () => void) {
        const requete: RequeteModifierRoles = {
            employeId: employeId,
            roleIds: [this.role.roleId],
            operation: "add",
            creeParId: 1 // TODO: Récupérer l'ID de l'utilisateur connecté
        };

        this.employeService.ModifierRoles(requete).subscribe({
            next: (success) => {
                if (callback) callback();
            },
            error: (error) => {
                console.error('Erreur lors de l\'ajout de l\'employé au rôle', error);
                if (callback) callback();
            }
        });
    }

    /**
     * Retire un employé d'un rôle
     */
    retirerEmployeDuRole(employeId: number, callback?: () => void) {
        const requete: RequeteModifierRoles = {
            employeId: employeId,
            roleIds: [this.role.roleId],
            operation: "remove",
            creeParId: 1 // TODO: Récupérer l'ID de l'utilisateur connecté
        };

        this.employeService.ModifierRoles(requete).subscribe({
            next: (success) => {
                if (callback) callback();
            },
            error: (error) => {
                console.error('Erreur lors du retrait de l\'employé du rôle', error);
                if (callback) callback();
            }
        });
    }

    /**
     * Obtient les IDs des rôles d'un employé
     * Note: Cette méthode est maintenant utilisée pour la compatibilité avec l'API existante
     */
    getEmployeRoleIds(employeId: number): number[] {
        const employe = this.employesDisponibles.find(e => e.employeId === employeId);
        return employe?.roles?.map(r => r.roleId) || [];
    }

    /**
     * Ferme le dialogue
     */
    fermerDialogue(avecChangements: boolean = false) {
        this.chargementEnCours = false;
        this.ref.close(avecChangements);
    }

    /**
     * Annule les modifications
     */
    annuler() {
        this.fermerDialogue(false);
    }

    /**
     * Obtient les tâches ajoutées
     */
    getTachesAjoutees(): TacheEntite[] {
        return this.tachesSelectionnees.filter(tache => 
            !this.tachesInitiales.some(t => t.tacheId === tache.tacheId)
        );
    }

    /**
     * Obtient les tâches supprimées
     */
    getTachesSupprimees(): TacheEntite[] {
        return this.tachesInitiales.filter(tache => 
            !this.tachesSelectionnees.some(t => t.tacheId === tache.tacheId)
        );
    }

    /**
     * Obtient les employés ajoutés
     */
    getEmployesAjoutes(): EmployeEntite[] {
        return this.employesSelectionnes.filter(employe => 
            !this.employesInitiaux.some(e => e.employeId === employe.employeId)
        );
    }

    /**
     * Obtient les employés supprimés
     */
    getEmployesSupprimes(): EmployeEntite[] {
        return this.employesInitiaux.filter(employe => 
            !this.employesSelectionnes.some(e => e.employeId === employe.employeId)
        );
    }

    /**
     * Vérifie s'il y a des modifications en attente
     */
    hasModifications(): boolean {
        return this.getTachesAjoutees().length > 0 || 
               this.getTachesSupprimees().length > 0 ||
               this.getEmployesAjoutes().length > 0 || 
               this.getEmployesSupprimes().length > 0;
    }

    /**
     * Vérifie si une tâche sera ajoutée
     */
    isTacheAjoutee(tache: TacheEntite): boolean {
        return this.modeEdition && this.getTachesAjoutees().some(t => t.tacheId === tache.tacheId);
    }

    /**
     * Vérifie si une tâche sera supprimée
     */
    isTacheSupprimee(tache: TacheEntite): boolean {
        return this.modeEdition && this.getTachesSupprimees().some(t => t.tacheId === tache.tacheId);
    }

    /**
     * Vérifie si un employé sera ajouté
     */
    isEmployeAjoute(employe: EmployeEntite): boolean {
        return this.modeEdition && this.getEmployesAjoutes().some(e => e.employeId === employe.employeId);
    }

    /**
     * Vérifie si un employé sera supprimé
     */
    isEmployeSupprime(employe: EmployeEntite): boolean {
        return this.modeEdition && this.getEmployesSupprimes().some(e => e.employeId === employe.employeId);
    }

    /**
     * Affiche les rôles d'un employé dans une boîte de dialogue
     * @param event L'événement de clic
     * @param employe L'employé dont on veut voir les rôles
     */
    voirRolesEmploye(event: Event, employe: EmployeEntite) {
        // Empêcher la propagation pour ne pas sélectionner/désélectionner l'item dans le pickList
        event.stopPropagation();
        event.preventDefault();
        
        this.employeService.ObtenirRolesEmploye(employe.employeId).subscribe({
            next: (roles) => {
                this.employe.roles = roles;
            },
            error: (error) => {
                console.error('Erreur lors de la récupération des rôles de l\'employé', error);
            }
        });
        this.employe = employe;
        this.afficherDialogueRolesEmploye = true;
    }
}
